__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/f24070f/packs/";